import { VenueExtraDto, VenueResponseDto } from "@/Dtos/venue-dto";

export function defaultValues(venue?: VenueResponseDto) {
    console.log(venue);
    return {
        name: venue?.name ?? "",
        priceType: venue?.priceType ?? "",
        remarks: venue?.remarks ?? "",
        price: venue?.price.toString() ?? "",
        capacity: venue?.capacity.toString() ?? "",
        extras: venue?.extras.map(defaultExtraValues) ?? [defaultExtraValues()],
    };
}

export function defaultExtraValues(extra?: VenueExtraDto) {
    return {
        name: extra?.entityExtra.name ?? "",
        description: extra?.description ?? "",
        price: extra?.entityExtra.price.toString() ?? "",
        isRequired: extra?.isRequired,
        priceIncluded: extra?.priceIncluded,
    };
}